const heroElement = document.querySelector('.c-hero');

if (heroElement) {
  const heroContent = heroElement.querySelector('.c-hero__head-inner');

  if (heroContent) {
    const heroContentBox = heroContent.getBoundingClientRect()
    heroElement.style.setProperty('--hero-content-offset', heroContentBox.height / 3 * 2)
  }
}
